import React from 'react'

import HomeContent from '../components/organisms/homeContent/homeContent'
import ParticipaSection from '../components/molecules/participaSection/participaSection'
import TopSection from '../components/molecules/topSection/topSection'
import TermsSection from '../components/molecules/termsSection/termsSection'

import PageLayout from '../components/templates/page-layout/page-layout'

import useMediaQuery from '../utils/useMediaQuery'

function IndexPage() {
  const isMobile = useMediaQuery()

  return (
    <PageLayout>
      <HomeContent isMobile={isMobile} />
      <ParticipaSection isMobile={isMobile} />
      <TopSection isMobile={isMobile} />
      <TermsSection />
    </PageLayout>
  )
}

export default IndexPage
